import {BaSeDialogModalConfig, BaSeTheme} from "@base/react";
import React from "react";
import CustomContentModal from "../components/CustomModalContent";
import {RenderContentProps} from "@base/react/build/contexts/dialog";

interface ModalConfig {
    type?: 'success' | 'hasExist' | 'error';
    titleOnSuccess?: string;
    titleOnError?: string;
    msgOnSuccess?: string;
    msgOnError?: string;
    msgOnHasExist?: string;
    onCloseModal?: () => void;
    showModal?: (config: BaSeDialogModalConfig) => void; // Confirme o tipo correto para BaSeDialogModalInterface ou algo similar
}


const renderContent = (renderContentProps: RenderContentProps, message: any) => {
    return (
        <CustomContentModal closeModal={renderContentProps.closeModal} emitEvent={renderContentProps.emitEvent}>
            {message}
        </CustomContentModal>
    );
};

type ModalType = 'success' | 'error' | 'hasExist';
const handleModalConfig = (config: ModalConfig) => {

    const modalConfig: Record<ModalType, any> = {
        'success': {
            id: 1,
            title: 'Sucesso',
            titleColor: BaSeTheme.colors.institucionais.cinzaSebrae45,
            size: 'medium',
            actions: [
                {
                    action: 'OK',
                    type: 'primary',
                    color: BaSeTheme.colors.feedbackInterface.sucesso20,
                },
            ],
            dismissable: true,
            content: (item: any) => renderContent(item, config.msgOnSuccess),
            onCancel: () => config.onCloseModal,
            onClose: (action: string) => config.onCloseModal,
        },
        'error': {
            id: 2,
            title: 'Erro',
            titleColor: BaSeTheme.colors.feedbackInterface.erro45,
            size: 'medium',
            actions: [
                {
                    action: 'OK',
                    type: 'primary',
                    color: BaSeTheme.colors.feedbackInterface.erro45,
                },
            ],
            dismissable: true,
            content: (item: any) => renderContent(item, config.msgOnError),
            onCancel: () => config.onCloseModal,
            onClose: (action: string) => config.onCloseModal,
        },
        'hasExist': {
            id: 3,
            title: 'Erro',
            titleColor: BaSeTheme.colors.feedbackInterface.erro45,
            size: 'medium',
            actions: [
                {
                    action: 'OK',
                    type: 'primary',
                    color: BaSeTheme.colors.feedbackInterface.erro45,
                },
            ],
            dismissable: true,
            content: (item: any) => renderContent(item, config.msgOnHasExist),
            onCancel: () => config.onCloseModal,
            onClose: (action: string) => config.onCloseModal,
        }
    }
    if (modalConfig.hasOwnProperty(config.type as ModalType)) {
        return modalConfig[config.type as ModalType];
    }
}
const useModalStatus = () => {
    const handleModalStatus = (newConfig: ModalConfig) => {
        if (newConfig.showModal) {
            const configModal = handleModalConfig(newConfig);
            newConfig.showModal(configModal);
        }
    };

    return {handleModalStatus};
};

export default useModalStatus;